import StartScreen from '../../components/Screens/StartScreen/StartScreen';
import React from 'react';
import PredictorController from '../PredictorController/PredictorController';
import { useGetActivePredictor } from '../../store/predictor/predictorActions';
import { usePredictorStore } from '../../store/predictor/predictorStore';
import LoadingScreen from '../../components/Screens/LoadingScreen/LoadingScreen';
import { isFail } from '../../common/serviceUtil';
import Error from '../../components/Error/Error';
import HistoryModalWrapper from '../../components/HistoryModal/HistoryModal';
import { devTools } from '../../common/devtools';

interface MainControllerProps {
  predictorId?: number;
}

const MainController = ({ predictorId }: MainControllerProps) => {
  const { data, status } = useGetActivePredictor(predictorId);
  const activePredictor = usePredictorStore((s) => s.activePredictor);
  devTools.log('using predictorId', predictorId);

  if (status === 'loading') return <LoadingScreen />;

  if (isFail(data) || status === 'error') return <Error />;
  return (
    <>
      <HistoryModalWrapper />
      {activePredictor ? <PredictorController /> : <StartScreen />}
    </>
  );
};

export default MainController;
